import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const StoryAnglesForm = ({ formData, onFormChange, onGenerate, isGenerating }) => {
  const angleTypeOptions = [
    { value: 'news-hook', label: 'News Hook' },
    { value: 'human-interest', label: 'Human Interest' },
    { value: 'trend-analysis', label: 'Trend Analysis' },
    { value: 'expert-opinion', label: 'Expert Opinion' },
    { value: 'behind-scenes', label: 'Behind the Scenes' },
    { value: 'controversy', label: 'Controversial Take' },
    { value: 'seasonal', label: 'Seasonal/Timely' }
  ];

  const industryFocusOptions = [
    { value: 'publishing', label: 'Publishing Industry' },
    { value: 'literature', label: 'Literature & Arts' },
    { value: 'education', label: 'Education' },
    { value: 'entertainment', label: 'Entertainment' },
    { value: 'business', label: 'Business' },
    { value: 'technology', label: 'Technology' },
    { value: 'lifestyle', label: 'Lifestyle' }
  ];

  const handleInputChange = (field, value) => {
    onFormChange({ ...formData, [field]: value });
  };

  return (
    <div className="space-y-6">
      <Input
        label="Book/Topic"
        type="text"
        placeholder="Enter the book title or main topic"
        value={formData?.topic || ''}
        onChange={(e) => handleInputChange('topic', e?.target?.value)}
        required
      />
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">
          Background Information
        </label>
        <textarea
          className="w-full h-32 px-3 py-2 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
          placeholder="Provide context about the book, author, or topic that could inspire story angles"
          value={formData?.background || ''}
          onChange={(e) => handleInputChange('background', e?.target?.value)}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Select
          label="Angle Type"
          options={angleTypeOptions}
          value={formData?.angleType || ''}
          onChange={(value) => handleInputChange('angleType', value)}
          placeholder="Select story angle type"
          required
        />
        <Select
          label="Industry Focus"
          options={industryFocusOptions}
          value={formData?.industryFocus || ''}
          onChange={(value) => handleInputChange('industryFocus', value)}
          placeholder="Select industry focus"
          required
        />
      </div>
      <Input
        label="Current Events/Trends"
        type="text"
        placeholder="Any current events or trends to tie into?"
        value={formData?.currentEvents || ''}
        onChange={(e) => handleInputChange('currentEvents', e?.target?.value)}
      />
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">
          Target Publications
        </label>
        <textarea
          className="w-full h-24 px-3 py-2 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
          placeholder="Which publications or media outlets are you targeting? (e.g., Publishers Weekly, BookBub, local newspapers)"
          value={formData?.targetPublications || ''}
          onChange={(e) => handleInputChange('targetPublications', e?.target?.value)}
        />
      </div>
      <Button
        onClick={onGenerate}
        loading={isGenerating}
        iconName="Lightbulb"
        iconPosition="left"
        className="w-full"
        disabled={!formData?.topic || !formData?.angleType || !formData?.industryFocus}
      >
        {isGenerating ? 'Generating Story Angles...' : 'Generate Story Angles & Headlines'}
      </Button>
    </div>
  );
};

export default StoryAnglesForm;